import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'errorMessage',
  standalone: true,
})
export class ErrorMessagePipe implements PipeTransform {
  transform(errorName: string, error: any): unknown {
    let msg = '';

    switch (errorName.toLowerCase()) {
      case 'notnull':
        msg = 'This field is required';
        break;
      case 'required':
        msg = 'This field is required';
        break;
      case 'pattern':
        msg = 'Invalid format. Must match: ' + error.requiredPattern;
        break;
      case 'maxlength':
        msg = 'Value too long. Max length: ' + error.requiredLength;
        break;
      case 'minlength':
        msg = 'Value too short. Min length: ' + error.requiredLength;
        break;
      case 'email':
        msg = 'Email address is not valid';
        break;
      case 'unique':
        msg = 'Entry must be unique';
        break;
      case 'age':
        msg = 'Age is invalid. ' + error.type + ' age: ' + error.required + ', actual: ' + error.actual;
        break;
      default:
        if (typeof error === 'string') {
          msg = error;
        } else {
          console.log(error);
        }
        break;
    }
    return msg;
  }
}
